import "./style.css"
const PrintContentWrapper = ({ children, printRef, className="" }) => {
    return (
        <div className={`print-content-wrapper ${className}`} ref={printRef} > {children}</div >
    )
}

export default PrintContentWrapper